import json from './sprite.js';

export default {
    handle: 'SP_SPT2-Kites',
    label: 'es_SPT2-Kites_234684238',
    json,
};
